export default "__VITE_ASSET__6c3bdbd0__"